import React, { useEffect, useState } from "react";
import { Tabs, Modal, Button, Input, Radio, Tag, message } from "antd";
import {
  BellOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import "../../App.css";
import eventicon from "../../Assets/calender/Event-icon.png";
import taskicon from "../../Assets/calender/Task-icon.png";
import DateCalender from "./DateCalender";
import TimeSelect from "./TimeSelect";
import Reminder from "./Reminder";
import { URL } from "../../helper/Mainurl";
import FloatLabel from "../FloatLabel";
import ChecklistComponent from "../ChecklistComponent";
import DetailsList from "../DetailsList";
import "./FilterModal.css";
import "./AddTask.css";
import DateModalTask from "./DateModalTask";
import moment from "moment";
import AssignToModal from "./AssignToModal";
import CollaborationModal from "./CollaborationModal";
import RepeatModal from "./RepeatModal";
import {
  AssessmentOutlined,
  AssignmentOutlined,
  ColorLensOutlined,
  RepeatOn,
  RepeatOneOnOutlined,
  RepeatOnOutlined,
  RepeatOnRounded,
  RepeatOnSharp,
  RepeatOnTwoTone,
  RepeatOutlined,
} from "@mui/icons-material";
import ColorsModal from "./ColorsModal";
const AddTask = ({
  isModalOpen,
  closeModal,
  getCalenderData,
  CalenderStartDate,
  CalenderEndDate,
  defaultDate,
}) => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage

  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => { }, [activeTab]);
  // const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [timeModalOpen, setTimeModalOpen] = useState(false);
  const [isReminderOpen, setIsReminderOpen] = useState(false);
  const [radioMeta, setRadioMeta] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [inputText, setInputText] = useState("");
  const [inputTextDesc, setInputTextDesc] = useState(null);
  const [locationText, setLocationText] = useState(null);
  const [error, setError] = useState(false);
  const [submitLoadting, setSubmitLoadting] = useState(false);

  const [selectedRadioId, setSelectedRadioId] = useState(null);

  const [checklist, setChecklist] = useState([
    { title: "", description: null, is_checked: 1 },
  ]);
  const [newChecklistText, setNewChecklistText] = useState("");
  const [editingItemId, setEditingItemId] = useState(null);
  const [value, setValue] = useState(1);
  const [selectedTime, setSelectedTime] = useState({ start: "", end: "" });
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [switchStates, setSwitchStates] = useState(false);
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  useEffect(() => {
    if (defaultDate !== null && defaultDate !== undefined) {
      setSelectedDate(defaultDate);
      setSwitchStates(true);
    } else if (defaultDate === null) {
      setSelectedDate(null);
      setSwitchStates(false);
    }
  }, [defaultDate]);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);
  const [selectReminder, setSelectReminder] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [showColorModal, setShowColorModal] = useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [colorMetaData, setColorMetaData] = useState([]);
  const [descSelectedColor, setDescSelectedColor] = useState("No color");
  const [selectedColorForPayload, setSelectedColorForPayload] = useState("");
  const [AssignData, setAssignData] = useState([]);
  const [CollaborateData, setCollaborateData] = useState([]);
  const [permission, setPermission] = useState([]);
  const [repeatOption, setRepeatOption] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [invitees, setInvitees] = useState();

  const [dummyCollaborators, setDummyCollaborators] = useState([]);

  const [showRepeatModal, setShowRepeatModal] = useState(false);

  // State for switch toggle
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [colorConfigure, setColorConfigure] = useState(null);

  // Repeat settings configuration
  const [repeatConfig, setRepeatConfig] = useState(null);
  // Toggle repeat switch
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };

  const getRepeatDescription = () => {
    if (!switchStatesRepeat || !repeatConfig) return "No repeat";

    const { repeatType, endType, occurrences, customEndDate } = repeatConfig;

    if (!repeatType?.label_name) return "No repeat";

    const endText =
      endType === "custom"
        ? `until ${moment(customEndDate).format("D MMMM YYYY")}`
        : `after ${occurrences} ${occurrences === 1 ? "year" : "years"}`;

    return `${repeatType.label_name} (Ends ${endText})`;
  };

  // Handle saving from RepeatModal
  const handleRepeatSave = (data) => {
    setRepeatConfig(data);
    // const {
    //   repeatType,
    //   endType,
    //   occurrences,
    //   customEndDate,
    //   adjustWeekends,
    //   excludeWeekends
    // } = repeatConfig;

    // console.log("Repeat Type:", repeatType?.value); // e.g., "weekly"
    // console.log("End Type:", endType);              // e.g., "custom" or "after"
    // console.log("Occurrences:", occurrences);       // e.g., 5
    // console.log("Custom End Date:", customEndDate); // e.g., "2025-07-01"
    // console.log("Adjust Weekends:", adjustWeekends); // e.g., "previous_friday"
    // console.log("Exclude Weekends:", excludeWeekends); // e.g., [{ id: 1, label: 'saturday' }]

    //   console.log('setRepeatConfig', repeatConfig);
    // You can perform side effects here, such as API calls or other logic

    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
  };
  useEffect(() => { }, [repeatConfig]);
  // Cancel modal
  const handleRepeatCancel = () => {
    // If no config and switch is off, don't keep modal open
    if (!repeatConfig) {
      setSwitchStatesRepeat(false);
    }
    setShowRepeatModal(false);
  };

  const handleSwitchChangeCollaboration = (checked) => {
    setSwitchStatesCollaboration(checked);
  };

  const handleSaveCollaboration = (selected) => {
    // Separate new invitees
    const newInvites = selected.filter((user) => user.newInvitee);
    const confirmedCollaborators = selected.filter((user) => !user.newInvitee);

    // Set only confirmed collaborators
    setSelectedCollaborators(confirmedCollaborators);
    setSwitchStatesCollaboration(confirmedCollaborators.length > 0);
    setShowCollaborationModal(false);

    // Deduplicate collaborators by id
    setDummyCollaborators((prev) => {
      const all = [...prev, ...confirmedCollaborators];
      const unique = [];
      const seen = new Set();
      for (const user of all) {
        if (!seen.has(user.id)) {
          unique.push(user);
          seen.add(user.id);
        }
      }
      return unique;
    });

    // Extract and set unique invitees
    if (newInvites.length > 0) {
      const invitePayload = newInvites.map((invitee) => ({
        email: invitee.email,
        permission_id: String(invitee.permission.id),
      }));
      setSwitchStatesCollaboration(true);
      setInvitees((prev = []) => {
        const existingEmails = new Set(prev.map((i) => i.email));
        const filteredNew = invitePayload.filter(
          (i) => !existingEmails.has(i.email)
        );
        return [...prev, ...filteredNew];
      });
    }
  };

  const getTabName = (key) => (key == "1" ? "task" : "event");

  const tabName = getTabName(activeTab); // Convert tab number to "task" or "event"

  // Use useEffect to log or handle side effects when selectedCollaborators changes
  useEffect(() => {
    if (selectedCollaborators.length > 0) {
      // console.log("Collaborators updated:", selectedCollaborators, invitees);
      // Additional logic like API calls or state updates can go here
    }
  }, [selectedCollaborators]);

  // Description for selected collaborators
  const descSelectedCollaboration =
    selectedCollaborators.length > 0 || (invitees?.length ?? 0) > 0
      ? [
        ...selectedCollaborators.map((c) => c.name),
        ...(invitees || []).map((i) => i.email.split("@")[0]),
      ].join(", ")
      : tabName === "event"
        ? "No participants selected"
        : "No collaborators selected";

  // This will log the description
  // console.log("Description of selected collaborators:", descSelectedCollaboration);

  // const userList = [
  //   {
  //     id: "1",
  //     name: "John Doe",
  //     email: "john.doe@example.com",
  //     avatar: "https://randomuser.me/api/portraits/men/1.jpg",
  //   },
  //   {
  //     id: "2",
  //     name: "Jane Smith",
  //     email: "jane.smith@example.com",
  //     avatar: "https://randomuser.me/api/portraits/women/2.jpg",
  //   },
  //   {
  //     id: "3",
  //     name: "Alice Johnson",
  //     email: "alice.johnson@example.com",
  //     avatar: "https://randomuser.me/api/portraits/women/3.jpg",
  //   },
  //   {
  //     id: "4",
  //     name: "Bob Brown",
  //     email: "bob.brown@example.com",
  //     avatar: "https://randomuser.me/api/portraits/men/4.jpg",
  //   },
  // ];

  const selectedNames =
    assignedUsers.length > 0
      ? assignedUsers.map((u) => u.name).join(", ")
      : "No assign";

  const handleAssignSave = (newSelection) => {
    // console.log("newSelection", newSelection);
    setAssignedUsers(newSelection);
    setShowAssignModal(false);
  };
  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setShowModal(false); // Close modal after selecting a date
    setSwitchStates(!!date); // Correctly update state
    // console.log("Selected Date:", date);
  };

  const handleSwitchChange = () => {
    setShowModal(true);
  };
  const handleSwitchChangeTime = () => {
    setShowTimeModal(true);
  };
  const handleSwitchChangeaAssign = () => { };
  const handleSwitchChangeRem = () => {
    const newState = !switchStatesRem;
    setSwitchStatesRem(newState);
    if (!newState) {
      // If the switch was ON and now turned OFF, show the modal
      // setShowRemModal(true);
      setSwitchStatesRem(false);
      setDescSelectedReminder("");
    } else {
      // If the switch was OFF and now turned ON
      setSelectedReminder(null);
      setSwitchStatesRem(true); // Ensure the switch turns ON
      setShowRemModal(true);
    }
  };
  const handleSwitchChangeColor = () => {
    const newState = !switchStatesColor;
    setSwitchStatesColor(newState);

    if (newState) {
      // If turning ON, open the modal
      setShowColorModal(true);
    } else {
      // If turning OFF, just clear the color, don't open modal
      setSelectedColorForPayload("");
      setDescSelectedColor("No color");
    }
  };

  const handleSelectDisplay = (id) => {
    setSelectedDisplayId(id); // Store only one selected ID
  };

  // Handle selecting a Priority
  const handleSelectPriority = (id) => {
    setSelectedPriorityIds(id);
  };

  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setRadioMeta(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setPriority(data.data.priority);
        setColorMetaData(data.data.colors);
        setPermission(data.data.permissions);
        setRepeatOption(data.data.repeat_option);
        setAdjustWeekend(data.data.adjust_weekends);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) { }
  };

  useEffect(() => {
    getCalenderMetaData();
  }, []);

  const onChange = (key) => {
    console.log(key);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
  };

  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    // Validate selected date
    if (!selectedDate || !selectedTime?.start) {
      return { taskStartTime: null, reminderText: "No reminder" };
    }

    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );

    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = moment(
      selectedTime?.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "No reminder" };
    }

    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    // If no reminder is selected, return "No reminder"
    if (!selectedReminder) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const reminderTime = moment.utc(selectedReminder); // Convert reminder to UTC
    const eventStartTime = moment.utc(taskStartTime); // Convert event start to UTC

    // Validate reminder time
    if (!reminderTime.isValid() || reminderTime.isAfter(eventStartTime)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = eventStartTime.diff(reminderTime, "minutes") || 0;
    const diffHours = eventStartTime.diff(reminderTime, "hours") || 0;
    const diffDays = eventStartTime.diff(reminderTime, "days") || 0;

    let reminderText = "No reminder"; // Default value

    if (diffDays === 0 && diffHours === 0 && diffMinutes > 0) {
      reminderText = `${diffMinutes} minutes before`;
    } else if (diffDays === 0 && diffHours > 0) {
      reminderText = `${diffHours} hours, ${diffMinutes % 60} minutes before`;
    } else if (diffDays > 0) {
      reminderText = `${diffDays} days, ${diffHours % 24} hours, ${diffMinutes % 60
        } minutes before`;
    }

    return { taskStartTime, reminderText };
  };

  const handleSelectTime = (timeData) => {
    setSelectedTime(timeData);

    setSwitchTimeStates(!!timeData);
    // Example output: { startTime: "08:00", endTime: "09:00" }
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      selectedReminder
    );

    setDescSelectedReminder(reminderText);
  };

  const handleSelectReminder = (reminder, checked) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);
  };

  const selectTextReminder = (item) => {
    setDescSelectedReminder(item);
  };

  useEffect(() => {
    // console.log("AssignData", AssignData)
  }, []);

  const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
    "YYYY-MM-DD"
  );
  // Ensure start time, end time, and reminder timestamp are in ISO 8601 UTC format
  let formattedDate = moment(formattedStartDate);
  if (!formattedDate.isValid()) {
    formattedDate = moment(
      selectedDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );
  }

  const handleSubmitNew = async () => {
    setSubmitLoadting(true);
    if (!inputText || !inputText.trim()) {
      setError(true);
      setSubmitLoadting(false);
      message.error(`${tabName} name is required!`);
      return;
    }
    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    // Ensure start time, end time, and reminder timestamp are in ISO 8601 UTC format
    let formattedDate = moment(formattedStartDate);
    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }
    // console.log("selectedTime", selectedTime.start);
    let formattedStartTime = moment(
      selectedTime.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`,
        "YYYY-MM-DD HH:mm"
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    let formattedEndTime = moment(
      selectedTime.end,
      ["HH:mm", "HH:mm:ss"],
      true
    );

    const taskEndTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime.format(
          "HH:mm"
        )}`,
        "YYYY-MM-DD HH:mm"
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const formattedReminder = moment(selectedReminder, "YYYY-MM-DD HH:mm")
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    // const checkedItems = checklist.filter(item => item.checked).map(item => item.text);
    // console.log("sdkjhf", checklist);
    const checkListItems = checklist.map((item) => ({
      title: item.title,
      // description: '', // You can customize the description here
      is_checked: item.is_checked,
    }));

    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };

    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );

    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    const transformedCollaborators = selectedCollaborators.map((collab) => ({
      member_id: Number(collab.id),
      permission_id: String(collab.permission.id),
    }));

    const finalAssignees =
      assignedUsers && assignedUsers?.map((user) => parseInt(user.id));
    const taskPayload = {
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: selectedTime?.start ? taskStartTime : null,
      end_time: taskEndTime,
      reminder_timestamp: switchStatesRem ? formattedReminder : null, // If task-related, include checklist
      color_id: switchStatesColor ? selectedColorForPayload : null,
      assignees: finalAssignees,
      collaborators: transformedCollaborators,
      repeat_option: repeatConfig?.repeatType?.value || null,
      repetition_end_date: getRepetitionEndDate(),
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? true
        : false,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? true
        : false,
      adjust_weekends: adjustWeekendsValue,
      invitees: invitees,
    };

    // Payload for Event (with additional fields like event description)
    const participants = selectedCollaborators.map((collab) => ({
      member_id: Number(collab.id),
      permission_id: String(collab.permission.id),
    }));
    const eventPayload = {
      title: inputText,
      location: locationText,
      description: inputTextDesc,
      display_name_id: selectedDisplayId,
      priority_id: selectedPriorityIds,
      progress_status_id: selectedRadioId,
      start_date: formattedStartDate,
      start_time: selectedTime?.start ? taskStartTime : null,
      end_time: taskEndTime,
      assignees: finalAssignees,
      reminder_timestamp: switchStatesRem ? formattedReminder : null, // If task-related, include checklist
      check_list: checkListItems, // If event-related, include checklist
      color_id: switchStatesColor ? selectedColorForPayload : null,
      participants: participants,
      repeat_option: repeatConfig?.repeatType?.value || null,
      repetition_end_date: getRepetitionEndDate(),
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? true
        : false,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? true
        : false,
      adjust_weekends: adjustWeekendsValue,
      invitees: invitees,
    };

    const payload = tabName === "task" ? taskPayload : eventPayload;

    // console.log("Final Payload:", payload);
    // return
    try {
      const response = await fetch(`${URL}/v1/${tabName}/create`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.code === 200) {
        message.success(`${tabName} created successfully`);
        // getCalenderData()

        resetFormFields();
        closeModal();
        if (CalenderStartDate && CalenderEndDate) {
          await getCalenderData(CalenderStartDate, CalenderEndDate);
        }
        // Clear form fields and state after successful submission

        setError(false);
      } else {
        setSubmitLoadting(false);
        message.error(data.message);
      }
    } catch (error) {
      setSubmitLoadting(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // Reset form fields when the active tab changes
    resetFormFields();
  }, [activeTab]); //
  const resetFormFields = () => {
    setInputText(null);
    setInputTextDesc(null);
    setLocationText(null);
    if (!isModalOpen) {
      setSelectedDate(null);
    }
    setSelectedTime({ start: "", end: "" });
    setSelectedReminder("No reminder");
    setDescSelectedReminder("No reminder");
    setDescSelectedColor("No color");
    setSwitchStatesColor(false);
    setSelectedDisplayId(null);
    setSelectedPriorityIds(null);
    setSwitchStatesCollaboration(false);
    setSwitchStatesRepeat(false);
    setSelectedRadioId(null);
    if (!isModalOpen) {
      setSwitchStates(null);
    }
    setSwitchTimeStates(false);
    setSwitchStatesRem(false);
    setChecklist([]); // Reset checklist
  };

  const handleChange = (e) => {
    setInputText(e.target.value);
    setError(false); // Clear error when user types

    // Update state on input change
  };

  const handleChangeDesc = (e) => {
    setInputTextDesc(e.target.value); // Update state on input change
  };
  const handleChangeLocation = (e) => {
    setLocationText(e.target.value); // Update state on input change
  };

  const handleRadioChange = (e) => {
    const slectedStatusID = e.target.value;
    setSelectedRadioId(slectedStatusID);
  };

  const handleColorSave = (selectedColor) => {
    if (selectedColor) {
      // update description text
      setDescSelectedColor(selectedColor.label_name);
      setSwitchStatesColor(true); // ✅ Turn on the switch if color is selected

      // update full object for payload
      setSelectedColorForPayload(selectedColor.id);
    }
    message.success("Color added successfully");

    setShowColorModal(false);
  };

  const handleColorCancel = () => {
    setShowColorModal(false);
  };

  const fetchCollabaroteDate = async () => {
    try {
      const response = await fetch(`${URL}/v1/member/get-members-list`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setCollaborateData(data.data);
        // console.log("data.data::::::", data.data);
        if (data.data) {
          const { members, permissions } = data.data;

          const transformAssign = members.map((member) => ({
            id: String(member.id),
            name: member.name,
            email: member.email,
            avatar: member.profile_image,
            permission:
              permissions.find((p) => p.id === member.permission_id)
                ?.label_name || "Can View",
          }));

          const transformedCollaborators = members.map((member) => ({
            id: String(member.id),
            name: member.invitee_nickname,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformPermission = permissions;

          // console.log("AssignData", transformAssign);
          // console.log("transformPermission", transformPermission);

          setAssignData(transformAssign);
          setDummyCollaborators(transformedCollaborators);
          setPermission(transformPermission);
        }
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) { }
  };

  useEffect(() => {
    fetchCollabaroteDate();
  }, []);

  const iconStyle = { fontSize: 22, color: "#666", marginRight: 8 };

  const options = [
    { label: "Pending", value: "pending" },
    { label: "Success", value: "success" },
  ];
  const eventContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label={'What is the name of your Event '}
          name="taskTitle"
          value={inputText}
          required
        >
          <Input
            placeholder=""
            value={inputText}
            onChange={handleChange}
            required
            style={{ height: 45 }}
          />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <div>
        <FloatLabel
          label="Description"
          name="taskDescription"
          value={inputTextDesc}
        >
          <Input
            placeholder=""
            value={inputTextDesc}
            onChange={handleChangeDesc}
            style={{ height: 45 }}
          // autoSize={{ minRows: 1, maxRows: 6 }}
          />
        </FloatLabel>
      </div>
      <div>
        <FloatLabel label="Location" name="taskLocation" value={locationText}>
          <Input
            placeholder=""
            value={locationText}
            onChange={handleChangeLocation}
            style={{ height: 45 }}
          />
        </FloatLabel>
      </div>

      <div>
        <ChecklistComponent checklist={checklist} setChecklist={setChecklist} />
      </div>
      {/* Status */}
      <div className="radio-container">
        <h3>Status <span style={{ color: 'red' }}>*</span></h3>
        <Radio.Group
          className="custom-radio-group"
          onChange={handleRadioChange}
        >
          {radioMeta.length > 0 ? (
            radioMeta.map((status) => (
              <Radio key={status.id} value={status.id} className="custom-radio">
                {status.label_name}
              </Radio>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </Radio.Group>
      </div>
      <div className="display-container">
        <h3>Preferred Display Name <span style={{ color: 'red' }}>*</span></h3>
        <div className="">

          {displayName.map((status) => (
            <Tag
              onClick={() => handleSelectDisplay(status.id)}
              style={{
                backgroundColor:
                  selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedDisplayId === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",
                cursor: "pointer",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
              }}
              key={status.id}
            >
              {status.label_name}
            </Tag>
          ))}
        </div>
      </div>
      {/* Priority */}
      <div className="priority-container">
        <h3>Priority <span style={{ color: 'red' }}>*</span></h3>
        <div className="">
          {priority.length > 0 ? (
            priority.map((status) => (
              <Tag
                onClick={() => handleSelectPriority(status.id)}
                style={{
                  backgroundColor:
                    selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                  color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                  border:
                    selectedPriorityIds === status.id
                      ? "1px solid #9A4FE0"
                      : "1px solid #E1E6EF",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontSize: "14px",
                  padding: "8px 12px",
                  lineHeight: "18px",
                }}
                key={status.id}
              >
                {status.label_name}
              </Tag>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </div>
      </div>

      {/* Details Section */}
      <div className="details-container">
        <h3 className="details-title">Detail</h3>
        {/* <DetailsList
        icon={<AssignmentOutlined />}
        title="Assign To"
        description={selectedNames}
        switchChecked={assignedUsers.length > 0}
        onSwitchChange={() => setShowAssignModal(true)}
        onClick={() => setShowAssignModal(true)}
      /> */}
        <DetailsList
          icon={<AssessmentOutlined style={iconStyle} />}
          title="Participants"
          description={descSelectedCollaboration}
          switchChecked={switchStatesCollaboration}
          onSwitchChange={() => setShowCollaborationModal(true)}
          onClick={() => setShowCollaborationModal(true)}
        />
        <DetailsList
          icon={<CalendarOutlined style={iconStyle} />}
          title="Date"
          description={selectedDate || "No date selected"}
          switchChecked={switchStates}
          onSwitchChange={() => handleSwitchChange()}
          onClick={() => setShowModal(true)} // Open modal on click
          required
        />

        <DetailsList
          icon={<ClockCircleOutlined style={iconStyle} />}
          title="Time"
          description={
            selectedTime.start && selectedTime.end
              ? `${selectedTime.start} - ${selectedTime.end}`
              : "Add time"
          }
          switchChecked={switchTimeStates}
          onSwitchChange={() => handleSwitchChangeTime()}
          onClick={() => setShowTimeModal(true)}
          required
        />

        <DetailsList
          icon={<BellOutlined style={iconStyle} />}
          title="Reminder"
          description={
            descSelectedReminder === "No reminder"
              ? "No Reminder"
              : descSelectedReminder
          }
          switchChecked={switchStatesRem}
          onSwitchChange={() => handleSwitchChangeRem}
          onClick={() => setShowRemModal(true)}
        />
        <DetailsList
          icon={<RepeatOnOutlined style={iconStyle} />}
          title="Repeat"
          description={getRepeatDescription()}
          switchChecked={switchStatesRepeat}
          onSwitchChange={handleSwitchChangeRepeat}
          onClick={() => setShowRepeatModal(true)}
        />
        <DetailsList
          icon={<ColorLensOutlined style={iconStyle} />}
          title="Color"
          description={descSelectedColor}
          switchChecked={switchStatesColor}
          onSwitchChange={handleSwitchChangeColor}
          onClick={() => setShowColorModal(true)}
        />
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
          gap: "5px"
        }}
      >
        <Button onClick={closeModal} className="modal-cancel-btn">
          Cancel
        </Button>
        <Button
          type="primary"
          loading={submitLoadting}
          disabled={submitLoadting}
          className="modal-success-btn"
          onClick={handleSubmitNew}
        >
          Save
        </Button>
      </div>
    </div>
  );
  const taskContent = (
    <div>
      <div className="addTaskLabel">
        <FloatLabel
          label="What is the name of your task"
          name="taskTitle"
          value={inputText}
          required
        >
          <Input placeholder="" value={inputText} onChange={handleChange} style={{ height: 45 }} />
        </FloatLabel>
        {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
      </div>

      <FloatLabel
        label="Description"
        name="taskDescription"
        value={inputTextDesc}
      >
        <Input
          value={inputTextDesc}
          placeholder=""
          onChange={handleChangeDesc}
          style={{ height: 45 }}
        // autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </FloatLabel>

      <FloatLabel label="Location" name="taskLocation" value={locationText}>
        <Input
          placeholder=""
          value={locationText}
          onChange={handleChangeLocation}
          style={{ height: 45 }}
        />
      </FloatLabel>

      {/* <div>
      <ChecklistComponent checklist={checklist} setChecklist={setChecklist} />
    </div> */}
      {/* Status */}
      <div className="radio-container">
        <h3>Status <span style={{ color: 'red' }}>*</span></h3>
        <Radio.Group
          className="custom-radio-group"
          onChange={handleRadioChange}
        >
          {radioMeta.length > 0 ? (
            radioMeta.map((status) => (
              <Radio key={status.id} value={status.id} className="custom-radio">
                {status.label_name}
              </Radio>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </Radio.Group>
      </div>
      <div className="display-container">
        <h3>Preferred Display Name <span style={{ color: 'red' }}>*</span></h3>
        <div className="">

          {displayName.map((status) => (
            <Tag
              onClick={() => handleSelectDisplay(status.id)}
              style={{
                backgroundColor:
                  selectedDisplayId === status.id ? "#FEF1FE" : "#ffffff",
                color: selectedDisplayId === status.id ? "#9A4FE0" : "#000",
                border:
                  selectedDisplayId === status.id
                    ? "1px solid #9A4FE0"
                    : "1px solid #E1E6EF",
                borderRadius: "10px",

                cursor: "pointer",
                fontSize: "14px",
                padding: "8px 12px",
                lineHeight: "18px",
              }}
              key={status.id}
            >
              {status.label_name}
            </Tag>
          ))}
        </div>
      </div>
      {/* Priority */}
      <div className="priority-container">
        <h3>Priority <span style={{ color: 'red' }}>*</span></h3>
        <div className="">
          {priority.length > 0 ? (
            priority.map((status) => (
              <Tag
                onClick={() => handleSelectPriority(status.id)}
                style={{
                  backgroundColor:
                    selectedPriorityIds === status.id ? "#FEF1FE" : "#ffffff",
                  color: selectedPriorityIds === status.id ? "#9A4FE0" : "#000",
                  border:
                    selectedPriorityIds === status.id
                      ? "1px solid #9A4FE0"
                      : "1px solid #E1E6EF",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontSize: "14px",
                  padding: "8px 12px",
                  lineHeight: "18px",
                }}
                key={status.id}
              >
                {status.label_name}
              </Tag>
            ))
          ) : (
            <p>Loading...</p> // Optional loading state
          )}
        </div>
      </div>

      {/* Details Section */}
      <div className="details-container">
        <h3 className="details-title">Detail</h3>
        <DetailsList
          icon={<AssignmentOutlined style={iconStyle} />}
          title="Assign To"
          description={selectedNames}
          switchChecked={assignedUsers.length > 0}
          onSwitchChange={() => setShowAssignModal(true)}
          onClick={() => setShowAssignModal(true)}
        />
        <DetailsList
          icon={<BellOutlined style={iconStyle} />}
          title="Collaboration"
          description={descSelectedCollaboration}
          switchChecked={switchStatesCollaboration}
          onSwitchChange={() => setShowCollaborationModal(true)}
          onClick={() => setShowCollaborationModal(true)}
        />
        <DetailsList
          icon={<CalendarOutlined style={iconStyle} />}
          title="Date"
          description={selectedDate || "No date selected"}
          switchChecked={switchStates}
          onSwitchChange={() => handleSwitchChange()}
          onClick={() => setShowModal(true)} // Open modal on click
          required
        />

        <DetailsList
          icon={<ClockCircleOutlined style={iconStyle} />}
          title="Time"
          description={
            selectedTime.start && selectedTime.end
              ? `${selectedTime.start} - ${selectedTime.end}`
              : "Add time"
          }
          switchChecked={switchTimeStates}
          onSwitchChange={() => handleSwitchChangeTime()}
          onClick={() => setShowTimeModal(true)}
          required
        />

        <DetailsList
          icon={<BellOutlined style={iconStyle} />}
          title="Reminder"
          description={
            descSelectedReminder === "No reminder"
              ? "No Reminder"
              : descSelectedReminder
          }
          switchChecked={switchStatesRem}
          onSwitchChange={() => handleSwitchChangeRem()}
          onClick={() => setShowRemModal(true)}
        />
        <DetailsList
          icon={<RepeatOutlined style={iconStyle} />}
          title="Repeat"
          description={getRepeatDescription()}
          switchChecked={switchStatesRepeat}
          onSwitchChange={handleSwitchChangeRepeat}
          onClick={() => setShowRepeatModal(true)}
        />
        <DetailsList
          icon={<ColorLensOutlined style={iconStyle} />}
          title="Color"
          description={descSelectedColor}
          switchChecked={switchStatesColor}
          onSwitchChange={() => handleSwitchChangeColor()}
          onClick={() => setShowColorModal(true)}
        />
      </div>

      {/* Footer */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
          gap: "5px"
        }}
      >
        <Button onClick={closeModal} className="modal-cancel-btn">
          Cancel
        </Button>
        <Button
          type="primary"
          loading={submitLoadting}
          disabled={submitLoadting}
          className="modal-success-btn"
          onClick={handleSubmitNew}
        >
          Save
        </Button>
      </div>
    </div>
  );

  // console.log("selectedTime123", selectedTime)
  return (
    <>
      <Modal
        title="Add Task"
        open={isModalOpen}
        onCancel={closeModal}
        footer={false}
        maskClosable={false}
      >
        <div>
          <div>
            <div style={{ fontSize: "16px", fontWeight: "600" }}>Category</div>
            <Tabs
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={setActiveTab}
              className="custom-tabs"
            >
              <Tabs.TabPane
                tab={
                  <span>
                    <img src={taskicon} width={12} /> Task
                  </span>
                }
                key="1"
              >
                {taskContent}
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <span>
                    <img src={eventicon} width={12} /> Events
                  </span>
                }
                key="2"
              >
                {eventContent}
              </Tabs.TabPane>
            </Tabs>
          </div>
        </div>
      </Modal>
      <div>
        {/* <DateCalender isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} onSelectDate={handleSelectDate} /> */}
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          selectedDate={selectedDate}
        />
      </div>

      <div>
        {showTimeModal && <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedDate={selectedDate}
        />}
      </div>
      <div>
        {showRemModal && <Reminder
          show={showRemModal}
          handleClose={() => setShowRemModal(false)}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={selectTextReminder}
        />}
        {showAssignModal && (
          <AssignToModal
            visible={showAssignModal}
            onCancel={() => setShowAssignModal(false)}
            onSave={handleAssignSave}
            selectedUsers={assignedUsers}
            users={AssignData}
          />
        )}
        {showCollaborationModal && (
          <CollaborationModal
            visible={showCollaborationModal}
            onCancel={() => setShowCollaborationModal(false)}
            onSave={handleSaveCollaboration}
            collaborators={dummyCollaborators}
            initialSelected={selectedCollaborators}
            permissionMetadata={permission}
            tabName={tabName} // <-- Pass the tab name here
          />
        )}
        <RepeatModal
          visible={showRepeatModal}
          onCancel={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          adjustWeeknd={adjusWeekend}
          startDate={formattedStartDate} // 👈 This must be defined above this point
        />
        <ColorsModal
          visible={showColorModal}
          onCancel={handleColorCancel}
          onSave={handleColorSave}
          metaData={colorMetaData}
        />
      </div>
    </>
  );
};

export default AddTask;
